{
  "name": "@ns/company-connect-approve",
  "version": "2.1.0",
  "requiredPermission": "RELATIONSHIPS_MANAGE",
  "description": "Review and respond to a connection request",
  "inputs": {
    "relationshipId": {
      "type": "string"
    },
    "notes": {
      "type": "string",
      "optional": true
    }
  },
  "outcomes": {
    "accept": {},
    "reject": {}
  }
}
